import React from "react"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete'; //https://material-ui.com/components/autocomplete/
import COMPANYUNIVERSE from "../data/companies.json"
import COMPANYUNIVERSEOPTIONSONLY from "../data/companies_options.json"
import INDEXUNIVERSE from "../data/indexes.json"  
import {logEvent} from "../analytics";

/**
 * @typedef {Object} TickerDropDownItem
 * @property {string} ticker
 * @property {string} name
 */

/** @returns {TickerDropDownItem} */
const toTickerDropDownItem = (item) => ({
  ticker: item.ticker,
  name: item.name
});

/** @returns {TickerDropDownItem[]} */
const sortTickerList = (items) => [...items].sort((a, b) => {
  const leftTicker = (a?.ticker || "").replace(/^\^/, "");
  const rightTicker = (b?.ticker || "").replace(/^\^/, "");
  return leftTicker.localeCompare(rightTicker);
});

const INDEXESWITHOPTIONS = INDEXUNIVERSE.filter((index)=>index.has_options===true);

export default class TickerDropDown extends React.Component 
  {
    state = {
      selectedCompany: this.getDefault()
    }
    selectionChanged = (event,newValue) =>  {
        this.setState({selectedCompany:newValue})
        const newTicker=(newValue == null) ? "" : newValue.ticker
        this.props.onSelectedTickerChanged(newTicker); //pass it up to container
        logEvent("tickerChanged",{ticker:newTicker});
    }
    getDefault() {
      return this.TickerList().find((item)=>item.ticker===this.props.defaultTicker)
    }
    //indicates whether we should be displaying only companies which have option chains
    //if the OptionsOnly flag isn't set, we'll default to false
    optionsOnlyMode() {
      if (Object.keys(this.props).includes('OptionsOnly')) {
        return (this.props.OptionsOnly === true);
      }
      return false;
    }
    excludeIndexesMode() {
      if (Object.keys(this.props).includes('excludeIndexes')) {
        return (this.props.excludeIndexes === true);
      }
      return false;
    }
    TickerList() {
      if (this.optionsOnlyMode()===true) {
        const optionsOnlyTickers = this.excludeIndexesMode()
          ? COMPANYUNIVERSEOPTIONSONLY
          : [...COMPANYUNIVERSEOPTIONSONLY, ...INDEXESWITHOPTIONS];
        return sortTickerList(optionsOnlyTickers.map(toTickerDropDownItem));
      }
      const allTickers = this.excludeIndexesMode()
        ? COMPANYUNIVERSE
        : [...COMPANYUNIVERSE, ...INDEXUNIVERSE];
      return sortTickerList(allTickers.map(toTickerDropDownItem));
    }
   
    render() {
        return (
            <Autocomplete
              id="tickerSelect"
              value={this.state.selectedCompany}
              options={this.TickerList()}
              getOptionLabel={(option) => `${option.ticker} - ${option.name}`}
              style={{ width: 300 }}
              onChange={this.selectionChanged}
              renderInput={(params) => <TextField {...params} label="Ticker" variant="outlined" helperText={this.props.helperText}/>}
            />
        );
    }
  

  }